/**
 * User-facing expectations for PDF size / per-upload processing (see SERVER_MAX_PDF_PAGES on backend).
 */

/** Typical per-file server cap for Full Analysis / Convert when SERVER_MAX_PDF_PAGES is set (e.g. 120 on Render). */
export const ANALYZER_MAX_PAGES_PER_FILE = 120;

/**
 * Why splitting matters on the Analyzer — paired with the in-tab Split PDF mode.
 */
export const ANALYZER_SPLIT_PDF_GUIDANCE =
  `Full Analysis and Convert each read at most about ${ANALYZER_MAX_PAGES_PER_FILE} pages per PDF in one run. Longer statements may be truncated or look incomplete. Splitting breaks your file into smaller PDFs (default ${ANALYZER_MAX_PAGES_PER_FILE} pages each, first-page headers repeated on later parts). Unzip the download, then upload each part with Full Analysis or Convert so the tool can process everything reliably. Splitting does not use your analysis page quota.`;

export const LARGE_PDF_UPLOAD_NOTICE =
  'Very large PDFs (for example thousands of pages) are not fully processed in one upload. Each run analyzes up to a server safety limit per file, and your page quota applies across all uploads. Split long statements into smaller PDFs (such as by month or year) and upload the parts separately to cover the full period.';

export const LARGE_PDF_LOADING_HINT =
  'Large files can take several minutes. Extremely long PDFs may need to be split into smaller files so each run can finish reliably.';

/** Short CTA; Analyzer tab has Split PDF built-in; `/split-pdf` remains available. */
export const SPLIT_PDF_TOOL_CTA =
  `Use Split PDF on the Analyzer tab or the standalone Split PDF page to download a ZIP of smaller files (default ${ANALYZER_MAX_PAGES_PER_FILE} pages each), then upload each part for analysis.`;
